import Contact from '@/entities/Contact.js';
import Model from './Model.js';
import User from './User.js';

export default class Payment extends Model {
    static get defaults() {
        return {
            contact_id: null,
            sender_id: null,

            amount: 0,
            invoice_number: null,
            expires_at: null,
            paid_at: null,
            seen_at: null,
            sent_at: null,

            // Belongs to
            _contact: new Contact(),
            _sender: new User(),
        };
    }

    get contact() {
        return this._contact;
    }

    get sender() {
        return this._sender;
    }

    set contact(value) {
        if (value) {
            this._contact = new Contact(value);
            this.contact_id = value.id;
        }
    }

    set sender(value) {
        if (value) {
            this._sender = new User(value);
            this.sender_id = value.id;
        }
    }
}
